import { motion } from "framer-motion";
import useStyles from "./styles";
import { useRef, useEffect } from "react";
import Navbar from "../../component/Navbar/NavBar";
import Footer from "../../Footer/Footer";

const Privacy = () => {
  const classes = useStyles();
  const FooterRef = useRef(null);
  const FAQRef = useRef(null);
  const HowitworksRef = useRef(null);
  const AboutRef = useRef(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Navbar
        FooterRef={FooterRef}
        HowitworksRef={HowitworksRef}
        AboutRef={AboutRef}
        FAQRef={FAQRef}
      />
      <div className={classes.root}>
        <div className={classes.margincont}>
          <div className={classes.container}>
            <motion.div
              className={classes.content}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <h1 className={classes.title}>PRIVACY POLICY</h1>
              <p className={classes.lastUpdate}>Last Update : Oct 21st, 2025</p>

              <div className={classes.section}>
                <p className={classes.intro}>
                  This Privacy Policy explains how personal information is collected, used, stored, and disclosed by SlotFinance . (Slotfinance "we," "us," and "our").
                  We take your privacy seriously because you matter. Here's how we handle your information.
                </p>
              </div>

              <div className={classes.section}>
                <h2 className={classes.heading}>Information Extracted</h2>
                <ul className={classes.list}>
                  <li><strong>Account Info:</strong> Entails name, email, password, DOB, gender, mobile number, address and referral code</li>
                  <li><strong>Financial Info:</strong> Bank details, Job description, Salary range, risk appetite and transaction history.</li>
                  <li><strong>Login Info:</strong> Login activity, device info, in app actions.</li>
                </ul>
              </div>

              <div className={classes.section}>
                <h2 className={classes.heading}>How Information is used</h2>
                <ul className={classes.list}>
                  <li><strong>Service run:</strong> To manage accounts & groups, initiate contributions & payments, send out reminders & notifications and generate virtual accounts.</li>
                  <li><strong>Safety:</strong> Verification process, curb / prevent fraud, legal requirement compliance.</li>
                </ul>
              </div>

              <div className={classes.section}>
                <h2 className={classes.heading}>What you see as a Member</h2>
                <p className={classes.text}>
                  As you join a group, members see:
                </p>
                <ul className={classes.list}>
                  <li>Name and Profile Picture</li>
                  <li>Role</li>
                  <li>Slot Selection and Contribution status</li>
                  <li>Bank details for payment purpose</li>
                  <li>Finance Capability (rating)</li>
                </ul>
              </div>

              <div className={classes.section}>
                <h2 className={classes.heading}>Who be we share with</h2>
                <ul className={classes.list}>
                  <li>Payment channels/partners (list them)</li>
                  <li>Telcom services ( list them)</li>
                  <li>Analytics</li>
                  <li>Legal Requirement ( When asked by the law)</li>
                </ul>
                <p className={classes.note}>
                  <strong>NB:</strong> Advertisers Can never have access to your data!
                </p>
              </div>

              <div className={classes.section}>
                <h2 className={classes.heading}>Your Rights</h2>
                <ul className={classes.list}>
                  <li><strong>Access Given:</strong> Download and View your data at your convenience</li>
                  <li><strong>Update:</strong> Change profile, bank details, mobile number and address.</li>
                  <li><strong>Delete:</strong> Account deletion request (in the absence of no cycle)</li>
                  <li><strong>Communication:</strong> Notification preference</li>
                </ul>
              </div>

              <div className={classes.section}>
                <h2 className={classes.heading}>Protection Of Data</h2>
                <ul className={classes.list}>
                  <li>Storage encryption</li>
                  <li>Secured servers</li>
                  <li>Controlled access</li>
                  <li>Momental security audits</li>
                  <li>Get notified within 72hrs in a case of breach</li>
                </ul>
              </div>

              <div className={classes.section}>
                <h2 className={classes.heading}>Data Retention</h2>
                <ul className={classes.list}>
                  <li><strong>Active account:</strong> retained data while using Slotfinance</li>
                  <li><strong>After deletion:</strong> Immediate deletion of profile but transaction duration is kept.</li>
                  <li><strong>Inactive account:</strong> Account is deleted after 3 years of inactivity with prior notice.</li>
                </ul>
              </div>

              <div className={classes.section}>
                <h2 className={classes.heading}>Security</h2>
                <ul className={classes.list}>
                  <li><strong>Secured Password</strong></li>
                  <li>Strong password (upper case/smaller case/ number and Symbol use)</li>
                  <li>Biometric login option</li>
                  <li>Suspicious activity report</li>
                  <li>Log out on shared device</li>
                </ul>
              </div>

              <div className={classes.section}>
                <h2 className={classes.heading}>Important Notes</h2>
                <ul className={classes.list}>
                  <li><strong>Age Requirement:</strong> 18+ is the required age for Slotfinance users</li>
                  <li><strong>Biometrics:</strong> Finger print or Face ID logins that's activated on your device is not accessible to Slotfinance</li>
                  <li><strong>Calendar Sync:</strong> Reminders are what we add, your other itineraries are off limits.</li>
                  <li><strong>Referrals:</strong> Users invited by a member can only be seen. Users can also see who invited them.</li>
                </ul>
              </div>

              <div className={classes.section}>
                <h2 className={classes.heading}>CONTACT US</h2>
                <ul className={classes.list}>
                  <li><strong>Support:</strong> …..@slotfinance</li>
                  <li><strong>Info:</strong> ….. @slotfinance</li>
                  <li><strong>Event/Market:</strong> …..@slotfinance</li>
                </ul>
              </div>

              <div className={classes.section}>
                <p className={classes.consent}>
                  By using our Services, you consent to the terms of this Privacy Policy, as to allow us to utilise your data to serve you more accurately.
                </p>
                <p className={classes.consent}>
                  By accessing our Services and voluntarily providing us with the requested Personal Information, you consent to the collection and use of the information in accordance with this Privacy Policy. Your consent can be withdrawn at any time by sending a request to that effect to this e-mail: Contact@slotfinance.com.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
      <div ref={FooterRef}>
        <Footer />
      </div>
    </>
  );
};

export default Privacy;
